module.exports = __webpack_public_path__ + "img/0Q3B1666_L_WoodMatted.60d29540.jpg";